import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconInstagram = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.35894 1.01147C2.51005 1.01147 1.01123 2.51029 1.01123 4.35919V13.2864C1.01123 15.1353 2.51005 16.6342 4.35894 16.6342H13.2862C15.1351 16.6342 16.6338 15.1353 16.6338 13.2864V4.35919C16.6338 2.51029 15.1351 1.01147 13.2862 1.01147H4.35894ZM14.2498 4.36404C14.2498 4.89659 13.8181 5.32832 13.2856 5.32832C12.753 5.32832 12.3213 4.89659 12.3213 4.36404C12.3213 3.83147 12.753 3.39975 13.2856 3.39975C13.8181 3.39975 14.2498 3.83147 14.2498 4.36404ZM8.82272 6.14836C7.34571 6.14836 6.14835 7.34572 6.14835 8.82273C6.14835 10.2997 7.34571 11.4971 8.82272 11.4971C10.2997 11.4971 11.4971 10.2997 11.4971 8.82273C11.4971 7.34572 10.2997 6.14836 8.82272 6.14836ZM4.86264 8.82273C4.86264 6.63564 6.63563 4.86265 8.82272 4.86265C11.0098 4.86265 12.7828 6.63564 12.7828 8.82273C12.7828 11.0098 11.0098 12.7828 8.82272 12.7828C6.63563 12.7828 4.86264 11.0098 4.86264 8.82273Z"
        fill="currentColor"
      />
    </svg>
  );
};

IconInstagram.defaultProps = {
  className: null,
  rootClassName: null,
};

IconInstagram.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default IconInstagram;
